import { useContext, type ReactNode } from "react";
import { NavigationContext } from "@-/com.npmjs.expo-router/react-navigation";
import {
  ReleasableRouteBody,
  RouteBodyStateProvider,
} from "@-/dev.improve.haniverse.lib.navigation.route-body-state";
import { useIsNavigationTreeFocused } from "#use-is-navigation-tree-focused";

type ReleasableBrowseTabBodyProps = {
  children: ReactNode;
  /** Shown only if the hidden route is displayed before React receives its focus event. */
  fallback?: ReactNode;
};

/**
 * A Browse catalog's heavy body (rows, native views, catalog-wide query observers), released a
 * grace period after the route is hidden by another Browse tab, a pushed character page or another
 * bottom tab. See `ReleasableRouteBody`: keep filters and sort in the parent, and give the list
 * `scrollPosition`. Outside a navigator (isolated renders) the body simply stays mounted.
 */
export function ReleasableBrowseTabBody(props: ReleasableBrowseTabBodyProps) {
  const navigation = useContext(NavigationContext);
  return navigation === undefined ? (
    <RouteBodyStateProvider>{props.children}</RouteBodyStateProvider>
  ) : (
    <NavigatedReleasableBrowseTabBody {...props} />
  );
}

function NavigatedReleasableBrowseTabBody({ children, fallback }: ReleasableBrowseTabBodyProps) {
  return (
    <ReleasableRouteBody fallback={fallback} isVisible={useIsNavigationTreeFocused()}>
      {children}
    </ReleasableRouteBody>
  );
}
